module.exports = __webpack_public_path__ + "img/understand.50bddbcd.png";